/**
 * アクターの一覧（`/actors`）。名前だけを全件出す。
 *
 * 読む先は新しい表（`spec_graph_nodes`）である。名前は語の組み合わせから導かれるので
 * （クラス ＋ 限定する語）、材料の用語が未設定のアクターは名前を持たない。**その行を落とさず
 * ID で出す**（`displayLabel`）。落とすと、名前の材料を埋める人が「埋めるべき行」を一覧から
 * 見つけられなくなる。
 *
 * 絞り込み欄は置かない。アクターは業務の遂行主体を分類するマスターで、1 桁の件数で運用する
 * 集合である（本番実測 5 件）。全部が 1 画面に収まっている一覧の上に絞り込み欄を置くと、
 * 使い道の無い入力が最初に目に入る。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business アクターを名前だけで全件一覧し、マスター詳細へ繋ぐ。
 * @graph-connects useListMasters [calls] アクター一覧の取得
 */
import { useSearch } from '@tanstack/react-router';

import { useListMasters } from '../hooks/queries/spec-graph-element-master-queries.js';
import { toNamedNodeItems } from './element-master-list.js';
import { NamedNodeListPage } from './named-node-list.js';
import { pjTextOf } from './pj-search.js';
import { ACTORS_ROUTE } from './route-paths.js';

/**
 * @graph-node {Function}
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business アクターの一覧を描く。
 * @graph-connects useListMasters [calls] アクター一覧の取得
 * @graph-connects pjTextOf [calls] 検索条件の案件番号を文字列へ戻す
 */
export function ActorsPage() {
  const pj = pjTextOf(useSearch({ from: ACTORS_ROUTE }).pj);
  const { data, isLoading, error } = useListMasters('actor', pj);

  return (
    <NamedNodeListPage
      nodeType="Actor"
      titleKey="actors.title"
      emptyKey="actors.empty"
      items={toNamedNodeItems(data?.items)}
      isLoading={isLoading}
      error={error}
    />
  );
}
